<template>
    <div>
        <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
        <div class="row">
          <div class="col-md-12">
            <div class="top-list-small-toolbar">
                <div>
                    <h4 class="text-primary">Product Summary By Order</h4>
                    <div class="form-inline">
                        <div class="button-group">
                          <span><b>Company:</b> </span>
                          <select v-model="company_no" class="btn btn-sm btn-soft-outline-primary" :disabled="authUser.permissions.company_select_all === false">
                            <option value="">-- All --</option>
                            <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                          </select>
                          <span class="ml-1"><b>Product:</b></span>
                          <select v-model="product_type" class="btn btn-sm btn-soft-outline-primary">
                            <option value="">-- All --</option>
                            <option value="bahan-dagangan">Bahan Dagangan</option>
                            <option value="bahan-produksi">Bahan Produksi</option>
                          </select>
                        </div>
                        <div class="button-group ml-1">
                          <span class="mr-1"><b>Date:</b> </span>
                          <datetime v-model="date" format="dd/MM/yyyy" class="form-control" value-zone="local" zone="local"></datetime>
                        </div>
                        <button type="button" class="btn btn-sm  btn-hard-primary waves-light waves-effect" @click="refreshList">
                          <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                        </button>
                        <button type="button" class="btn btn-sm  btn-hard-primary waves-light waves-effect" @click="setMultiRow" :disabled="syncStatus !== ''">
                          <i class="fa fa-refresh" aria-hidden="true"></i> Get All
                        </button>
                         <small v-if="syncStatus" class="ml-2 text-warning"><i class="fa fa-spinner fa-spin"></i> {{ syncStatus }}</small>
                         <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery" />
                        <button class="btn btn-warning btn-sm pull-left dropdown-toggle" v-show="printStatus === true" type="button" id="print" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          <i class="fa fa-print" aria-hidden="true"></i> Print
                        </button>
                        <div class="dropdown-menu" aria-labelledby="print">
                          <a class="dropdown-item" href="javascript:void(0)" @click="print('pdf')">PDF</a>
                          <a class="dropdown-item" href="javascript:void(0)" @click="print('excel')">Excel</a>
                        </div>
                    </div>
                </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="card card-list">
              <div class="card-body">
                <div class="table-responsive">
                  <div class="table-responsive">
                    <table class="table table-item mb-0 table-sm table-striped font-14">
                        <thead>
                            <th  v-for="t in title" v-bind:key="t.prop" @click="sortTable(t.prop)" :class="t.align">
                              {{ t.name }}
                              <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                            </th>
                            <th>#</th>
                        </thead>
                        <tbody>
                            <tr v-for="d in filterData" :key="d.id">
                                <td><b class="text-ref-sales" @click="getProductDataByNo(d.product_no)" data-toggle="modal" data-target="#modalGetProductPurchasing" data-backdrop="static" data-keyboard="false">[{{ d.product_no }}]</b> {{ d.product_name }}</td>
                                <td>{{ d.uom_id }}</td>
                                <td>
                                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="d.qty_status === false"></span>
                                  <span v-else>
                                    {{ d.qty_saldo }}
                                  </span>
                                </td>
                                <!-- <td>{{ d.costs.cost_qty }} {{ d.costs.uom_id }}</td> -->
                                <td>
                                    <ul v-for="p in d.purchasing_orders" :key="p.id">
                                      <li>
                                        <b>({{ p.qty_remaining }} {{ p.uom_id }})</b> {{ p.order_no }} <b>{{ p.ref_no }}</b> {{ p.order_date | dateFormat('DD/MM/YYYY') }}  {{ p.vendor }}&nbsp;
                                        <span class="badge badge-success" v-if="p.type === 'manufacture'">{{ p.type }}</span>
                                        <span class="badge badge-primary" v-else>{{ p.type }}</span>
                                      </li>
                                    </ul>
                                </td>
                                <td>{{ d.purchasing_order_remaining }}</td>
                                <td>
                                  <ul v-for="s in d.sale_orders" :key="s.id">
                                    <li><b>({{ s.qty_remaining }} {{ s.uom_id }})</b> {{ s.order_no }} {{ s.order_date | dateFormat('DD/MM/YYYY') }} {{ s.customer }} <b>[ {{ s.salesman }} ]</b></li>
                                  </ul>
                                </td>
                                <td>{{ d.sale_order_remaining }}</td>
                                <td>
                                  <span class="badge badge-danger" v-if="d.saldo < 0">{{ d.saldo }}</span>
                                  <span v-else>{{ d.saldo }}</span>
                                </td>
                                <td>
                                  <span @click="setRow(d)"><i class="fa fa-refresh"></i></span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                   </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ProductShowModal @backRefresh="refreshList"/>
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { setMultiRowUrl, setRowUrl, productUrl, getHeader, report2Url } from '../config'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import ProductShowModal from '@/components/product/ProductShowModal.vue'

export default {
  name: 'ProductSummaryByOrder',
  props: ['scroll'],
  components: {
    Loading,
    ProductShowModal
  },
  data () {
    var date = new Date()
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      product_type: '',
      uom: null,
      printStatus: false,
      syncStatus: '',
      company_no: '',
      product_no: null,
      filterCompany: [],
      startDate: [date1, date2],
      dateNow: new Date(),
      date: new Date().toISOString(),
      company: null,
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      dataRaw: [],
      data: {},
      searchQuery: '',
      ascending: true,
      sortClick: false,
      sortColumn: 'product_name',
      title: [{
        name: 'Product',
        prop: 'product_name',
        align: 'text-left'
      }, {
        name: 'Uom',
        prop: 'uom_id',
        align: 'text-left'
      }, {
        name: 'Qty',
        prop: 'qty_saldo',
        align: 'text-left'
      }, {
        name: 'Purchasing Order',
        prop: 'purchasing_orders',
        align: 'text-left'
      }, {
        name: 'Qty',
        prop: 'purchasing_order_qty',
        align: 'text-left'
      }, {
        name: 'Sales Order',
        prop: 'sale_orders',
        align: 'text-left'
      }, {
        name: 'Qty',
        prop: 'sale_order_qty',
        align: 'text-left'
      }, {
        name: 'Saldo',
        prop: 'saldo',
        align: 'text-left'
      }],
      selectAll: false,
      selected: []
    }
  },
  mounted () {
    this.company_no = ''
    this.date = new Date().toISOString()
    this.$store.dispatch('getCompanyList')
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable,
      companyList: state => state.companies.companyList,
      authUser: state => state.users.authUser
    }),
    companyData () {
      var obj = {
        name: null,
        address: null,
        phone: null
      }
      const cmp = this.companyList.find(d => d.company_no === this.company_no)
      if (cmp) {
        obj = {
          name: cmp.name,
          address: cmp.address,
          phone: cmp.phone
        }
      }
      return obj
    },
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      return this.totalItems
    },
    filterData: function () {
      // Server-side search & pagination, only client-side sort
      var col = this.sortColumn
      var ascending = this.ascending
      return [...this.dataRaw].sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      })
    }
  },
  methods: {
    getProductDataByNo (product) {
      var payload = {
        product_no: product
      }
      this.$store.commit('SET_PRODUCT_BY_NO', payload)
      this.$store.dispatch('getProductByNo', payload)
    },
    async getProductNo (value) {
      this.product_no = value.product_no
      var date = new Date(value.date)
      this.startDate = [date, date]
      await this.refreshList()
    },
    async showReturPuchasing (no) {
      var payload = {
        return_no: no
      }
      this.$store.commit('SET_RETURN_BY_NO', payload)
      this.$store.dispatch('getReturnByNo', payload)
    },
    async getSyncData (value) {
      this.$Progress.start()
      this.loader.isLoading = true
      var date = new Date(value.date)
      var newDate = date.getFullYear() + '-' + (parseInt(date.getMonth()) + 1) + '-' + date.getDate()
      var obj = {
        date: newDate,
        product_no: this.product_no,
        type: 'all',
        company_no: this.company_no
      }
      console.log(obj)
      await axios.post(productUrl + '/cost/sync', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          console.log(error.response)
          this.$Progress.finish()
          this.loader.isLoading = false
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    showReturSales (no) {
      var payload = {
        return_no: no
      }
      this.$store.commit('SET_RETURN_BY_NO', payload)
      this.$store.dispatch('getReturnByNo', payload)
    },
    getCOGS (product, company) {
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var payload = {
        begin: begin,
        end: end,
        product_no: product,
        company_no: company
      }
      console.log(payload)
      this.company = company
      this.$store.dispatch('getProductCogsByNo', payload)
    },
    async setCOGS () {
      this.$Progress.start()
      this.loader.isLoading = true
      var array = this.selected
      var resp = {
        error: false,
        message: null
      }
      for (let i = 0; i < array.length; i++) {
        const detail = this.dataRaw.find(d => d.id === array[i])
        var data = {
          date: detail.purchasing_date,
          product_no: detail.product_no,
          type: 'all',
          company_no: detail.company_no
        }
        console.log(data)
        await axios.post(productUrl + '/cost/sync', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            console.log(response.data.message)
            resp.error = false
            resp.message = response.data.message
          })
          .catch(error => {
            console.log(error.response.data.message)
            this.$swal('Error', error.response.data.message + '[' + detail.product_no + ']', 'error')
            this.$Progress.finish()
            this.loader.isLoading = false
            throw error
          })
      }
      if (resp.error === false) {
        await this.$Progress.finish()
        this.loader.isLoading = false
        this.selected = []
        this.selectAll = false
        await this.$swal('Success', resp.message, 'success')
      }
    },
    showSaleNo (no) {
      var payload = {
        sale_no: no
      }
      this.$store.commit('SET_SALE_BY_NO', payload)
      this.$store.dispatch('getSaleByNo', payload)
    },
    showManufactureNo (no) {
      var payload = {
        manufacture_no: no
      }
      this.$store.commit('SET_MANUFACTURE_BY_NO', payload)
      this.$store.dispatch('getManufactureByNo', payload)
    },
    showInventoryNo (no) {
      var payload = {
        inventory_no: no
      }
      this.$store.commit('SET_INVENTORY_BY_NO', payload)
      this.$store.dispatch('getInventoryByNo', payload)
    },
    showPurchasingNo (no) {
      var payload = {
        purchasing_no: no
      }
      this.$store.commit('SET_PURCHASING_ID', payload)
      this.$store.dispatch('getPurchasingShowByNo', payload)
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      //   this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    async refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      var type = []
      if (this.product_type === 'bahan-dagangan') {
        type = [5]
      } else if (this.product_type === 'bahan-produksi') {
        type = [1, 2, 3, 4, 6]
      } else {
        type = null
      }
      var obj = {
        date: this.date,
        company_no: this.company_no,
        type: type
      }
      console.log(obj)
      console.log(productUrl + '/summary-order')
      await axios.post(productUrl + '/summary-order', obj, { headers: getHeader() })
        .then(response => {
          this.dataRaw = response.data.data
        })
        .catch(error => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      await this.$Progress.finish()
      this.loader.isLoading = false
      await this.setMultiRow()
    },
    async setMultiRow () {
      const array = this.dataRaw
      const BATCH_SIZE = 30
      const totalBatches = Math.ceil(array.length / BATCH_SIZE)

      for (let batch = 0; batch < totalBatches; batch++) {
        const start = batch * BATCH_SIZE
        const end = Math.min(start + BATCH_SIZE, array.length)
        const batchProducts = array.slice(start, end)
        const loop = batchProducts.map(p => p.product_no)

        this.syncStatus = 'Sync batch ' + (batch + 1) + '/' + totalBatches + ' (' + loop.length + ' products)...'

        const obj = {
          begin: '2022-01-01',
          end: this.date,
          product_no: loop,
          product_all: batchProducts
        }

        await axios.post(setMultiRowUrl, obj, { headers: getHeader(), timeout: 600000 })
          .then(response => {
            if (response.data && response.data.data) {
              var multRow = response.data.data
              // Update langsung per batch (gradual)
              for (let i = 0; i < array.length; i++) {
                for (let m = 0; m < multRow.length; m++) {
                  if (multRow[m].product_no === array[i].product_no) {
                    array[i].qty_saldo = multRow[m].total
                    array[i].qty_status = true
                    array[i].saldo = parseFloat(array[i].qty_saldo) + parseFloat(array[i].purchasing_order_remaining) - parseFloat(array[i].sale_order_remaining)
                  }
                }
              }
            }
          })
          .catch(error => {
            console.log('Batch ' + (batch + 1) + ' error:', error)
          })
      }

      this.syncStatus = ''
      this.printStatus = true
    },
    async setRow (product) {
      this.loader.isLoading = true
      var url = setRowUrl + '?begin=2022-01-01' + '&end=' + this.date + '&product_no=' + product.product_no + '&uom=' + product.uom_id
      await axios.get(url, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          product.qty_saldo = response.data.data.total
          product.qty_status = true
          if (parseFloat(response.data.data.total) !== parseFloat(product.costs.cost_qty)) {
            product.saldo = parseFloat(product.qty_saldo) + parseFloat(product.purchasing_order_remaining) - parseFloat(product.sale_order_remaining)
          }
          this.loader.isLoading = false
        })
        .catch(error => {
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
        })
    },
    async print (type) {
      this.$Progress.start()
      this.loader.isLoading = true
      var data = {
        format: type,
        data: this.dataRaw
      }
      console.log(data)
      if (data.length === 0) {
        this.$swal('Error', 'Data masih kosong', 'error')
        return false
      }
      await axios.post(report2Url + '/order-summary', data, { responseType: 'blob' })
        .then(response => {
          const objectUrl = URL.createObjectURL(response.data)
          console.log('Showing PDF...')
          window.open(objectUrl, '_blank')
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
        })
    }
  }
}
</script>

<style>
.text-ref-sales {
  color: #28A745;
  cursor: pointer;
}
</style>
